import { render, staticRenderFns } from "./editsellGroupDetail.vue?vue&type=template&id=51b0cb11&scoped=true"
import script from "./editsellGroupDetail.vue?vue&type=script&lang=js"
export * from "./editsellGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./editsellGroupDetail.vue?vue&type=style&index=0&id=51b0cb11&prod&lang=less&scoped=true"
import style1 from "./editsellGroupDetail.vue?vue&type=style&index=1&id=51b0cb11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b0cb11",
  null
  
)

export default component.exports